import React from 'react';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';

import DeviceStatus from '../DeviceStatus';
import { formatMbToGb, formatPrice } from '../../../utils/formatters';
import { getDeviceSn, getPrice, getUsageType } from '../../../utils/helpers';
import DeviceUsageType from '../DeviceUsageType';
import AlertIcon from '../../../assets/icons/common/AlertIcon';
import DeviceExpired from '../DeviceExpired';
import useWindowSize from '../../../hooks/useWindowSize';
import { DEVICES } from '../../../routes';
import { createNextChargeDate } from '../../../utils/dates';

import styles from './styles.module.scss';

const DeviceHomeItem = ({ deviceData }) => {
  let navigate = useNavigate();
  const windowSize = useWindowSize();
  const isResponsive = windowSize?.width < 900;
  const defaultImagePath = 'images/products/default-product-image.png';
  const device_info = deviceData?.meta?.device_info || {};
  const subscriptionId = deviceData?.id;
  const meta = deviceData?.meta || {};
  const deviceSn = getDeviceSn(deviceData?.properties);
  const expired = !!deviceData?.cancelled_at;
  const nextCharge = createNextChargeDate(deviceData?.next_charge_scheduled_at);
  const cycleStart = nextCharge.subtract(1, 'month').format('MMM D');
  const cycleEnd = nextCharge.subtract(1, 'day').format('MMM D');
  const { title, image, largeImage } = meta;
  const { connection_status_name } = device_info;
  const total_usage = deviceData?.meta?.usage?.total || 0;
  const planAmount = `${formatMbToGb(total_usage)}GB`;
  const isPlanInGb = typeof planAmount !== 'string';
  const usageType = getUsageType(meta.usage);
  const priceData = getPrice(deviceData);
  const price = `$${formatPrice(priceData)}/month`;
  const recommendUpgradePlan = ['High Usage', 'Out Of Data'].includes(
    usageType,
  );
  const deviceImage = isResponsive ? largeImage : image;

  const showDefaultImage = expired || !deviceSn;
  const clickHandler = () => {
    return navigate(`${DEVICES}?subscription_id=${subscriptionId}`);
  };
  return (
    <div
      onClick={clickHandler}
      data-cy={'device-home-item'}
      className={cn({
        [styles.deviceHomeItem]: true,
      })}
    >
      <div className={styles.deviceHomeItemMain}>
        {showDefaultImage ? (
          <img src={defaultImagePath} alt={title} />
        ) : (
          <img src={deviceImage} alt={title} />
        )}
        <div className={styles.deviceHomeItemInfo}>
          <div className={styles.deviceHomeItemTitle}>
            {title || 'Connection Unavailable'}{' '}
            {expired && <DeviceExpired></DeviceExpired>}
          </div>
          <ul className={styles.deviceHomeItemInfoDetails}>
            <li>
              {planAmount}
              {isPlanInGb && 'GB'} Plan
            </li>
            <li>{price}</li>
            {!expired && (
              <li className={styles.date}>
                {cycleStart} - {cycleEnd}
              </li>
            )}
          </ul>
        </div>
      </div>
      <ul className={styles.deviceHomeItemUsage}>
        {!expired && (
          <>
            {recommendUpgradePlan && (
              <li>
                <div className={styles.deviceHomeItemUpgrade}>
                  <AlertIcon></AlertIcon>
                  Recommend upgrade plan
                </div>
              </li>
            )}
            <li>
              <DeviceUsageType usageType={usageType}></DeviceUsageType>
            </li>
            {usageType && <li className={styles.separator}></li>}
          </>
        )}
        <li>
          <DeviceStatus
            className={styles.deviceHomeItemConnection}
            connectionStatusName={connection_status_name}
            isExpired={expired}
            expiredAsOffline
          ></DeviceStatus>
        </li>
      </ul>
    </div>
  );
};
export default DeviceHomeItem;
